import { Logger } from "DVWebNodeUtils"
import { PType } from "../integrations/aui"

export const promiseWithTimeout = <T>(promise: Promise<T>, ms: number, rejectResponse: string) => {
  let id: any = null
  let timeout = new Promise<T>((_, reject) => {
    id = setTimeout(() => {
      reject(rejectResponse)
    }, ms)
  })
  return Promise.race([promise, timeout]).then((result) => {
    clearTimeout(id)
    return result
  })
}

declare let window: Window & { P: PType }

type AuiModules = {
  moduleNames: string[]
  timeout: number
  logger: Logger
  logError?: boolean
}
export const auiModules = ({ moduleNames, timeout, logger, logError = true }: AuiModules) => (
  promiseWithTimeout<any>(
    new Promise((resolve, reject) => {
      if (typeof window.P !== 'undefined') {
        window.P.when(...moduleNames).execute((...modules: any[]) => {
          resolve(modules)
        })
      } else {
        reject('AUI Page Object is missing')
      }
    }),
    timeout,
    `AUI modules: [${moduleNames.join(', ')}] Timed out in ${timeout} ms`
  ).catch(err => {
    if (logError) {
      logger.error(err)
    }
  })
)